import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

type SortField = "full_name" | "short_name" | "nip" | "created_at"
type SortDirection = "asc" | "desc"
const PAGE_SIZE_OPTIONS = [25, 50, 100, 200] as const

export const Route = createFileRoute(
  "/_layout/WMS/contragents/contragents-list",
)({
  validateSearch: (search: Record<string, unknown>) => {
    const rawPage =
      typeof search.page === "number" ? search.page : Number(search.page ?? 1)
    const rawPageSize =
      typeof search.page_size === "number"
        ? search.page_size
        : Number(search.page_size ?? 50)
    const rawSortBy =
      typeof search.sort_by === "string" ? search.sort_by : "full_name"
    const rawSortDir =
      typeof search.sort_dir === "string" ? search.sort_dir : "asc"
    const normalizedPageSize = PAGE_SIZE_OPTIONS.includes(
      rawPageSize as (typeof PAGE_SIZE_OPTIONS)[number],
    )
      ? rawPageSize
      : 50
    const normalizedSortBy: SortField =
      rawSortBy === "short_name" ||
      rawSortBy === "nip" ||
      rawSortBy === "created_at"
        ? rawSortBy
        : "full_name"
    const normalizedSortDir: SortDirection =
      rawSortDir === "desc" ? "desc" : "asc"

    return {
      q: typeof search.q === "string" ? search.q : "",
      status: typeof search.status === "string" ? search.status : "",
      page: Number.isFinite(rawPage) && rawPage > 0 ? rawPage : 1,
      page_size: normalizedPageSize,
      sort_by: normalizedSortBy,
      sort_dir: normalizedSortDir,
    }
  },
  component: ContragentsListRoute,
})

const ContragentsListPage = lazy(
  () => import("../../../../components/WMS/Contragents/ContragentsListPage"),
)

function ContragentsListRoute() {
  return (
    <LazyRoutePage>
      <ContragentsListPage />
    </LazyRoutePage>
  )
}
